import React, { useEffect, useState, useRef } from "react";
import DepartmentTopbar from "./components/DepartmentTopbar";
import DepertmentSidebar from "./components/DepertmentSidebar";
import SuperAdminSidebar from "./components/SuperAdminSidebar";
import Topbar from "./components/Topbar";
import styles from "../../assets/css/Dashboard.module.css";
import { useNavigate } from "react-router-dom";
import { FaDownload, FaEdit, FaEye, FaHistory, FaRupeeSign, FaFilePdf, FaCheckCircle, FaTimes, FaCheck } from "react-icons/fa";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const parseDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("-");
    if (!day || !month || !year) return null;
    let fullYear = year;
    if (year.length === 2) {
        fullYear = "20" + year;
    }
    return new Date(`${fullYear}-${month}-${day}`);
};

function ChalanList() {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [reportPeriod, setReportPeriod] = useState({ start: "", end: "" });
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [noDataMessage, setNoDataMessage] = useState('');
    const [activeTab, setActiveTab] = useState('all');
    const tableRef = useRef();

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [funds, setFunds] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedEditRow, setSelectedEditRow] = useState(null);
    const [editChalanNo, setEditChalanNo] = useState('');
    const [editCategory, setEditCategory] = useState('');
    const [editSubCategory, setEditSubCategory] = useState('');
    const [editFund, setEditFund] = useState('');
    const [editAmount, setEditAmount] = useState('');
    const [editDate, setEditDate] = useState('');
    const [editPaymentType, setEditPaymentType] = useState('');
    const [editNotes, setEditNotes] = useState('');

    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedViewRow, setSelectedViewRow] = useState(null);

    const chalanDetailFields = selectedViewRow
        ? [
            { label: "Chalan No", value: selectedViewRow.memo_no || "-" },
            { label: "Amount", value: selectedViewRow.amount ? `₹${selectedViewRow.amount.toLocaleString('en-IN')}` : "-" },
            { label: "Fund", value: selectedViewRow.fund_name || "-" },
            { label: "User", value: selectedViewRow.user_name || "-" },
            { label: "Category", value: selectedViewRow.title || "-" },
            { label: "Sub Category", value: selectedViewRow.description && selectedViewRow.description.trim() !== "" ? selectedViewRow.description : "NIL" },
            { label: "Date", value: selectedViewRow.date || "-" },
            { label: "Payment Type", value: selectedViewRow.paymentType || "-" },
        ]
        : [];

    const viewModalNotes = selectedViewRow
        ? selectedViewRow.notes && selectedViewRow.notes.trim() !== "" && selectedViewRow.notes.trim().toLowerCase() !== "nil"
            ? selectedViewRow.notes
            : "No additional notes available."
        : "";

    const fetchCategories = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${apiBaseUrl}cash_catagory_list.php`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            if (data.success) {
                const formattedCategories = data.data.map((cat) => ({
                    id: cat.id,
                    catagory_name: cat.catagory_name,
                }));
                setCategories(formattedCategories);
            } else {
                toast.error(`Error fetching categories: ${data.message}`);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            toast.error('Failed to fetch categories.');
        }
    };

    const fetchSubCategories = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${apiBaseUrl}cash_subcatagory_list.php`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            if (data.success) {
                setSubCategories(data.data);
            } else {
                toast.error(`Error fetching subcategories: ${data.message}`);
            }
        } catch (error) {
            console.error('Error fetching subcategories:', error);
            toast.error('Failed to fetch subcategories.');
        }
    };

    const fetchFunds = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${apiBaseUrl}fundlist.php`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            if (data.success) {
                const formattedFunds = data.funds.map((fund) => ({
                    id: parseInt(fund.id, 10),
                    name: fund.fund_name,
                    total: parseFloat(fund.amount) || 0,
                }));
                setFunds(formattedFunds);
            } else {
                toast.error(`Error fetching funds: ${data.message}`);
            }
        } catch (error) {
            console.error('Error fetching funds:', error);
            toast.error('Failed to fetch funds.');
        }
    };

    const user_name = localStorage.getItem('user_name');
    const user_id = localStorage.getItem('user_id');
    const userType = localStorage.getItem('type');
    const userRole = localStorage.getItem('role');
    const isSuperAdmin = userRole === 'Super_Admin';

    const apiBaseUrl = process.env.REACT_APP_SUPER_ADMIN_API_URL;

    useEffect(() => {
        const fetchChalans = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(
                    `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/cash_chalan_list.php`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                if (data.status === 'success') {
                    const formattedChalans = data.data.map((item) => ({
                        id: item.id,
                        memo_no: item.chalan_no,
                        categoryId: item.catagory_id,
                        subCategoryId: item.subcatagory_id,
                        fund_id: item.fund_id,
                        amount: parseFloat(item.amount),
                        date: item.date,
                        paymentType: item.payment_type,
                        notes: item.note,
                        title: item.category_name,
                        description: item.subcategory_name,
                        fund_name: item.fund_name,
                        status: item.status,
                        user_name: item.user ? item.user.name : 'N/A'
                    }));
                    formattedChalans.sort((a, b) => new Date(b.date) - new Date(a.date));
                    setTableData(formattedChalans);
                    setFilteredData(formattedChalans);
                    setNoDataMessage('');
                } else {
                    if (data.message === 'No cash chalans found.') {
                        setTableData([]);
                        setFilteredData([]);
                        setNoDataMessage('No cash chalans found.');
                    } else {
                        console.error(`Error fetching chalans: ${data.message}`);
                        setTableData([]);
                        setFilteredData([]);
                    }
                }
            } catch (error) {
                console.error('Error fetching chalans:', error);
                setTableData([]);
                setFilteredData([]);
            }
            setLoading(false);
        };

        fetchChalans();
        return () => {
            if ($.fn.DataTable.isDataTable("#pwdTable")) {
                $("#pwdTable").DataTable().destroy();
            }
        };
    }, []);

    useEffect(() => {
        fetchCategories();
        fetchSubCategories();
        fetchFunds();
    }, []);

    // Helper to destroy DataTable safely
    const destroyDataTable = () => {
        if ($.fn.DataTable.isDataTable('#pwdTable')) {
            $('#pwdTable').DataTable().destroy();
        }
    };

    useEffect(() => {
        if (!loading && filteredData.length > 0) {
            // Only initialize if not already initialized
            if (!$.fn.DataTable.isDataTable('#pwdTable')) {
                $('#pwdTable').DataTable({
                    responsive: true,
                    pageLength: 10,
                    lengthMenu: [
                        [10, 25, 50, -1],
                        [10, 25, 50, "All"],
                    ],
                    order: [[1, "desc"]],
                    language: {
                        search: "Search:",
                        lengthMenu: "Show _MENU_ entries",
                        info: "Showing _START_ to _END_ of _TOTAL_ entries",
                        infoEmpty: "Showing 0 to 0 of 0 entries",
                        infoFiltered: "(filtered from _MAX_ total entries)",
                        paginate: {
                            first: "First",
                            last: "Last",
                            next: "Next",
                            previous: "Previous",
                        },
                    },
                });
            }
        }
        return () => {
            destroyDataTable();
        };
    }, [filteredData, loading]);

    const handleFilter = () => {
        if (!startDate || !endDate) return;
        destroyDataTable();

        const start = new Date(startDate);
        const end = new Date(endDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        if (!Array.isArray(tableData)) {
            setFilteredData([]);
            setReportPeriod({ start: startDate, end: endDate });
            return;
        }

        const filtered = tableData.filter((item) => {
            if (!item.date) return false;
            const itemDate = new Date(item.date);
            itemDate.setHours(0, 0, 0, 0);
            return itemDate >= start && itemDate <= end;
        });

        setFilteredData(filtered);
        setReportPeriod({ start: startDate, end: endDate });
    };

    const handleReset = () => {
        destroyDataTable();
        setStartDate("");
        setEndDate("");
        setReportPeriod({ start: "", end: "" });
        setFilteredData(Array.isArray(tableData) ? tableData : []);
    };

    const handleTabFilter = (tab) => {
        setActiveTab(tab);
        destroyDataTable();

        if (!Array.isArray(tableData)) {
            setFilteredData([]);
            return;
        }

        let filtered = tableData;

        if (tab === 'pending') {
            filtered = tableData.filter(item => item.status === '0'); // status 0 = pending
        } else if (tab === 'approved') {
            filtered = tableData.filter(item => item.status === '1'); // status 1 = approved
        }

        setFilteredData(filtered);
    };

    const getPendingCount = () => {
        if (!Array.isArray(tableData)) return 0;
        return tableData.filter(item => item.status === '0').length; // status 0 = pending
    };

    const getApprovedCount = () => {
        if (!Array.isArray(tableData)) return 0;
        return tableData.filter(item => item.status === '1').length; // status 1 = approved
    };

    const getAllCount = () => {
        return Array.isArray(tableData) ? tableData.length : 0;
    };



    const filteredSubCategories = subCategories.filter(sub => sub.catagory_id === editCategory);

    const handleViewDetails = (row) => {
        setSelectedViewRow(row);
        setShowViewModal(true);
    };

    const handleAccept = (row) => {
        setSelectedRow(row);
        setShowConfirmModal(true);
    };

    const handleEdit = (row) => {
        setSelectedEditRow(row);
        setEditChalanNo(row.memo_no);
        setEditCategory(row.categoryId);
        setEditSubCategory(row.subCategoryId);
        setEditFund(row.fund_id);
        setEditAmount(row.amount.toString());
        setEditDate(row.date);
        setEditPaymentType(row.paymentType);
        setEditNotes(row.notes);
        setShowEditModal(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        const categoryName = categories.find(c => c.id == editCategory)?.catagory_name;
        const subCategoryName = subCategories.find(s => s.id == editSubCategory)?.subcatagory_name;
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${apiBaseUrl}updateacceptchalan.php`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    chalan_id: selectedEditRow.id,
                    chalan_no: editChalanNo,
                    amount: editAmount,
                    fund_id: editFund,
                    catagory: categoryName,
                    subcatagory: subCategoryName,
                    date: editDate,
                    payment_type: editPaymentType,
                    note: editNotes
                }),
            });
            const data = await response.json();
            if (data.status === true) {
                // Update tableData and filteredData
                setTableData(prev => prev.map(item => item.id === selectedEditRow.id ? { ...item, memo_no: editChalanNo, categoryId: editCategory, subCategoryId: editSubCategory, fund_id: editFund, amount: parseFloat(editAmount), date: editDate, paymentType: editPaymentType, notes: editNotes, title: categoryName, description: subCategoryName, fund_name: funds.find(f => f.id == editFund)?.name || item.fund_name } : item));
                setFilteredData(prev => prev.map(item => item.id === selectedEditRow.id ? { ...item, memo_no: editChalanNo, categoryId: editCategory, subCategoryId: editSubCategory, fund_id: editFund, amount: parseFloat(editAmount), date: editDate, paymentType: editPaymentType, notes: editNotes, title: categoryName, description: subCategoryName, fund_name: funds.find(f => f.id == editFund)?.name || item.fund_name } : item));
                toast.success(data.message);
                setShowEditModal(false);
                setSelectedEditRow(null);
            } else {
                toast.error(`Error updating chalan: ${data.message}`);
            }
        } catch (error) {
            console.error('Error updating chalan:', error);
            toast.error('Failed to update chalan.');
        }
    };

    const confirmAccept = async () => {
        if (!selectedRow) return;
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${apiBaseUrl}acceptchalanamount.php`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    chalan_id: selectedRow.id,
                    amount: selectedRow.amount,
                    fund_id: selectedRow.fund_id,
                    catagory: selectedRow.title,
                    subcatagory: selectedRow.description,
                    note: selectedRow.notes
                }),
            });
            const data = await response.json();
            if (data.status === true) {
                toast.success(data.message);
                setTableData(prev => prev.map(item => item.id === selectedRow.id ? { ...item, status: '1' } : item));
                setFilteredData(prev => prev.map(item => item.id === selectedRow.id ? { ...item, status: '1' } : item));
            } else {
                toast.error(`Error accepting chalan: ${data.message}`);
            }
        } catch (error) {
            console.error('Error accepting chalan:', error);
            toast.error('Failed to accept chalan.');
        }
        setShowConfirmModal(false);
        setSelectedRow(null);
    };

    return (
        <>
            <DepartmentTopbar />
            <div className="d-flex">
                <DepertmentSidebar />
                <div className={styles.dashboardContainer}>
                    <div className="d-flex align-items-center mb-4">
                        <h2
                            className="mb-0"
                            style={{
                                color: "#2c3e50",
                                fontWeight: "500",
                                fontSize: "1.5rem",
                            }}
                        >
                            Chalan List
                        </h2>
                    </div>
                    <div
                        className="card mb-4"
                        style={{ borderRadius: "8px", backgroundColor: "#fff" }}
                    >
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div className="row g-3 align-items-end flex-grow-1">
                                    <div className="col-auto">
                                        <label className="form-label small text-muted mb-1">
                                            Start Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            style={{ width: "160px", borderColor: "#dee2e6" }}
                                        />
                                    </div>
                                    <div className="col-auto">
                                        <label className="form-label small text-muted mb-1">
                                            End Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            style={{ width: "160px", borderColor: "#dee2e6" }}
                                        />
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            className="btn btn-primary btn-sm px-4"
                                            onClick={handleFilter}
                                            disabled={!startDate || !endDate}
                                        >
                                            Apply Filter
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary btn-sm px-3 ms-2"
                                            onClick={handleReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body p-2">
                            <div className="mb-3">
                                <ul className="nav nav-tabs" id="pwdTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleTabFilter('all')}
                                            style={{
                                                border: 'none',
                                                backgroundColor: activeTab === 'all' ? '#007bff' : 'transparent',
                                                color: activeTab === 'all' ? 'white' : '#6c757d',
                                                padding: '8px 16px',
                                                borderRadius: '4px 4px 0 0',
                                                marginRight: '4px',
                                                fontWeight: activeTab === 'all' ? '500' : '400'
                                            }}
                                        >
                                            All ({getAllCount()})
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleTabFilter('pending')}
                                            style={{
                                                border: 'none',
                                                backgroundColor: activeTab === 'pending' ? '#007bff' : 'transparent',
                                                color: activeTab === 'pending' ? 'white' : '#6c757d',
                                                padding: '8px 16px',
                                                borderRadius: '4px 4px 0 0',
                                                marginRight: '4px',
                                                fontWeight: activeTab === 'pending' ? '500' : '400'
                                            }}
                                        >
                                            Pending ({getPendingCount()})
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === 'approved' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleTabFilter('approved')}
                                            style={{
                                                border: 'none',
                                                backgroundColor: activeTab === 'approved' ? '#007bff' : 'transparent',
                                                color: activeTab === 'approved' ? 'white' : '#6c757d',
                                                padding: '8px 16px',
                                                borderRadius: '4px 4px 0 0',
                                                marginRight: '4px',
                                                fontWeight: activeTab === 'approved' ? '500' : '400'
                                            }}
                                        >
                                            Approved ({getApprovedCount()})
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="table-responsive">
                                <table
                                    ref={tableRef}
                                    id="pwdTable"
                                    className="table table-bordered align-middle mb-0"
                                >
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start">Chalan No</th>
                                            <th className="text-start">Cashier</th>
                                            <th className="text-start">Category</th>
                                            <th className="text-start">Sub Category</th>
                                            <th className="text-start">Fund Name</th>
                                            <th className="text-start">Amount</th>
                                            <th className="text-start">Date</th>
                                            <th className="text-start">Payment Type</th>
                                            <th className="text-start">Note</th>
                                            <th className="text-start">Status</th>
                                            <th className="text-start" style={{ width: 120, verticalAlign: 'middle' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="11" className="text-center py-4">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : filteredData.length === 0 ? (
                                            <tr>
                                                <td colSpan="11" className="text-center text-muted py-4">
                                                    {noDataMessage || 'No data found for the selected date range'}
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="text-start">{row.memo_no}</td>
                                                    <td className="text-start">{row.user_name}</td>
                                                    <td className="text-start">{row.title}</td>
                                                    <td className="text-start">{!row.description || row.description.trim() === '' ? 'NIL' : row.description}</td>
                                                    <td className="text-start">{row.fund_name}</td>
                                                    <td className="text-start">₹{row.amount ? row.amount.toLocaleString('en-IN') : '0'}</td>
                                                    <td className="text-start">{row.date}</td>
                                                    <td className="text-start">{row.paymentType}</td>
                                                    <td className="text-start">{row.notes}</td>
                                                    <td className="text-start">
                                                        <span className={`badge ${row.status === '0' ? 'bg-warning text-dark' : row.status === '1' ? 'bg-success' : 'bg-secondary'}`}>
                                                            {row.status === '0' ? 'Pending' : row.status === '1' ? 'Approved' : row.status}
                                                        </span>
                                                    </td>
                                                    <td className="text-start" style={{ verticalAlign: 'middle' }}>
                                                        <div className="d-flex gap-2 justify-content-center">
                                                            {row.status === '0' && (
                                                                <>
                                                                    <button className="btn btn-success btn-sm" onClick={() => handleAccept(row)}>
                                                                        Accept
                                                                    </button>
                                                                    <button className="btn btn-info btn-sm" onClick={() => handleViewDetails(row)}>
                                                                        <FaEye />
                                                                    </button>
                                                                </>
                                                            )}
                                                            {row.status === '1' && (
                                                                <>
                                                                    <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
                                                                        <FaEdit />
                                                                    </button>
                                                                    <button className="btn btn-info btn-sm" onClick={() => handleViewDetails(row)}>
                                                                        <FaEye />
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="p-3 border-top">
                                <p className="mb-0 text-muted" style={{ fontSize: "0.875rem", borderLeft: "3px solid #007bff", paddingLeft: "10px" }}>
                                    <i className="far fa-calendar-alt me-2"></i>
                                    Report generated for the period: {reportPeriod.start || "-"} to {reportPeriod.end || "-"}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered size="md">
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="d-flex align-items-center">
                        <FaCheckCircle className="text-success me-2" />
                        Confirm Approval
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {selectedRow ? (
                        <div className="mb-3">
                            <FaRupeeSign size={48} className="text-success mb-3" />
                            <h3 className="text-success fw-bold mb-3">₹{selectedRow.amount.toLocaleString('en-IN')}</h3>
                            <h5 className="text-muted">Are you sure you want to accept this fund?</h5>
                        </div>
                    ) : null}
                    {selectedRow && (
                        <div className="bg-light p-3 rounded">
                            <div className="row">
                                <div className="col-sm-6">
                                    <strong>Fund:</strong> {selectedRow.fund_name}
                                </div>
                                <div className="col-sm-6">
                                    <strong>User:</strong> <span>{selectedRow.user_name}</span>
                                </div>
                                <div className="col-sm-6">
                                    <strong>Category:</strong> {selectedRow.title}
                                </div>
                                <div className="col-sm-6">
                                    <strong>Sub Category:</strong> {selectedRow.description || 'NIL'}
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="outline-secondary" onClick={() => setShowConfirmModal(false)} className="me-3">
                        <FaTimes className="me-1" />
                        No
                    </Button>
                    <Button variant="success" onClick={confirmAccept}>
                        <FaCheck className="me-1" />
                        Yes, Accept
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Chalan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleEditSubmit}>
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Chalan No</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={editChalanNo}
                                        onChange={(e) => setEditChalanNo(e.target.value)}
                                        placeholder="Enter Chalan No"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Select Category</Form.Label>
                                    <Form.Select
                                        value={editCategory}
                                        onChange={(e) => {
                                            setEditCategory(e.target.value);
                                            setEditSubCategory('');
                                        }}
                                    >
                                        <option value="">Select Category</option>
                                        {categories.map(cat => (
                                            <option key={cat.id} value={cat.id}>{cat.catagory_name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Select Sub Category</Form.Label>
                                    <Form.Select
                                        value={editSubCategory}
                                        onChange={(e) => setEditSubCategory(e.target.value)}
                                        disabled={!editCategory}
                                    >
                                        <option value="">Select Sub Category</option>
                                        {filteredSubCategories.map(sub => (
                                            <option key={sub.id} value={sub.id}>{sub.subcatagory_name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Select Fund</Form.Label>
                                    <Form.Select
                                        value={editFund}
                                        onChange={(e) => setEditFund(e.target.value)}
                                        disabled
                                    >
                                        <option value="">Select Fund</option>
                                        {funds.map(fund => (
                                            <option key={fund.id} value={fund.id}>{fund.name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Amount</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={editAmount}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                setEditAmount(value);
                                            }
                                        }}
                                        placeholder="Enter amount"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={editDate}
                                        onChange={(e) => setEditDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Payment Type</Form.Label>
                                    <Form.Select
                                        value={editPaymentType}
                                        onChange={(e) => setEditPaymentType(e.target.value)}
                                    >
                                        <option value="">Select Payment Type</option>
                                        <option value="Online">Online</option>
                                        <option value="Cash">Cash</option>
                                        <option value="Cheque">Cheque</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Notes</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={editNotes}
                                onChange={(e) => setEditNotes(e.target.value)}
                                placeholder="Enter notes"
                            />
                        </Form.Group>
                        <div className="d-grid">
                            <Button variant="success" type="submit">
                                Update Chalan
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center">
                        <FaEye className="text-info me-2" />
                        Chalan Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedViewRow && (
                        <div>
                            <div className="bg-light p-4 rounded mb-3 border">
                                <h4 className="text-primary fw-bold mb-4">Chalan Information</h4>
                                <Row className="gy-3 gx-4">
                                    {chalanDetailFields.map((field, idx) => (
                                        <Col md={6} key={idx}>
                                            <div className="d-flex flex-column">
                                                <span className="text-muted small">{field.label}</span>
                                                <span className="fw-semibold">{field.value}</span>
                                            </div>
                                        </Col>
                                    ))}
                                    <Col md={6}>
                                        <div className="d-flex flex-column">
                                            <span className="text-muted small">Status</span>
                                            <span>
                                                <span className={`badge ${selectedViewRow.status === '0' ? 'bg-warning text-dark' : selectedViewRow.status === '1' ? 'bg-success' : 'bg-secondary'}`}>
                                                    {selectedViewRow.status === '0' ? 'Pending' : selectedViewRow.status === '1' ? 'Approved' : selectedViewRow.status}
                                                </span>
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="bg-light p-4 rounded border">
                                <span className="text-muted small d-block mb-2">Notes</span>
                                <p className="mb-0">{viewModalNotes}</p>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowViewModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ChalanList;
